import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { ApiService } from "../../../services/api/api.service";
import { PaymentDetailInfoDto, PaymentListModelsDto, PaymentRefundRequestDto, PaymentStatusDto, RequestRefundDto } from "../models/payment.models";
import { UserInfoService } from "../../../services/user-info.service";
import { SortTableService } from "../../../services/sort-table.service";
import { FilterSearchResultDto } from "src/app/models/filter.model";

@Injectable({
  providedIn: "root",
})
export class PaymentDataService {
  agentId: string | undefined;
  userId: number | undefined;

  sort: string | undefined;

  constructor(
    private apiService: ApiService,
    private userInfoService: UserInfoService,
    private sortTableService: SortTableService
  ) {
    this.userInfoService.userId$.subscribe({
      next: (res) => {
        this.userId = res;
      },
    });

    this.userInfoService.agentId$.subscribe({
      next: (res) => {
        this.agentId = res;
      },
    });

    this.sortTableService.sortColum$.subscribe({
      next: (res) => {
        this.sort = res;
      },
    });
  }

  loadPaymentFilter(): Observable<any> {
    const url = `/agents/${this.agentId}/payments/filter`;
    return this.apiService.httpGet<any>(url);
  }

  loadSearchList(data: any): Observable<FilterSearchResultDto> {
    const url = `/agents/${this.agentId}/payments/filter/list?page_number=0&per_page=10`;
    return this.apiService.httpPost<FilterSearchResultDto>(url, data);
  }

  loadCardSavedList(): Observable<any> {
    const url = `/agents/${this.agentId}/refund-details/filter`;
    return this.apiService.httpGet<any>(url);
  }

  loadPaymentList(page: number, search: string | undefined = "", data?: any): Observable<PaymentListModelsDto> {
    const url = `/agents/${this.agentId}/payments/filter?page_number=${page}&per_page=20&${this.sort}&search=${search}`;
    return this.apiService.httpPost<PaymentListModelsDto>(url, data);
  }

  loadDetailPayment(id: number): Observable<PaymentDetailInfoDto> {
    const url = `/agents/${this.agentId}/payments/${id}`;
    return this.apiService.httpGet<PaymentDetailInfoDto>(url);
  }

  getPaymentStatus(id: number): Observable<PaymentStatusDto> {
    const url = `/agents/${this.agentId}/payments/${id}/status`;
    return this.apiService.httpGet<PaymentStatusDto>(url);
  }

  loadFile(filter: any): Observable<Blob> {
    const url = `/agents/${this.agentId}/reports/payments/download`;
    return this.apiService.httpPostBlob(url, filter);
  }

  refundRequestCall(body: PaymentRefundRequestDto): Observable<RequestRefundDto> {
    const url = `/banks/call`;
    return this.apiService.httpPost<RequestRefundDto>(url, body);
  }

  loadRefundFile(id: number): Observable<Blob> {
    const url = `/agents/${this.agentId}/refunds/${id}/files`;
    return this.apiService.httpGetBlob(url);
  }
}
